
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { AnalysisModalHeader } from "./analysis/AnalysisModalHeader";
import { AnalysisSearchBar } from "./analysis/AnalysisSearchBar";
import { AnalysisCategoriesList } from "./analysis/AnalysisCategoriesList";
import { AnalysisScoreChart } from "./analysis/AnalysisScoreChart";
import { CandidateInfoSection } from "./analysis/CandidateInfoSection";
import { useAnalysisData } from "./analysis/useAnalysisData";

interface CandidateAnalysisModalProps {
  analysis: any;
  isOpen: boolean;
  onClose: () => void;
  candidateName?: string;
  candidateFunction?: string;
  candidateSynthesis?: string;
}

export const CandidateAnalysisModal = ({ 
  analysis, 
  isOpen, 
  onClose,
  candidateName = "",
  candidateFunction = "",
  candidateSynthesis = ""
}: CandidateAnalysisModalProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const analysisData = useAnalysisData(analysis);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[90%] w-[90%] h-[98vh] max-h-[98vh] p-0 overflow-hidden bg-white border-0 shadow-lg rounded-sm flex flex-col">
        <AnalysisModalHeader 
          title="Candidate Analysis Report" 
          overallScore={analysisData.overallScore} 
        />
        
        <div className="flex-1 flex flex-col overflow-hidden">
          <CandidateInfoSection
            name={candidateName}
            function={candidateFunction}
            synthesis={candidateSynthesis}
          />
          
          <AnalysisSearchBar 
            searchQuery={searchQuery} 
            setSearchQuery={setSearchQuery} 
          />
          
          {analysisData.categories.some(cat => typeof cat.score === 'number') && (
            <AnalysisScoreChart categories={analysisData.categories} />
          )}
          
          <div className="flex-1 overflow-hidden">
            <AnalysisCategoriesList 
              categories={analysisData.categories} 
              searchQuery={searchQuery} 
            />
          </div>
        </div>
        
        <div className="py-2 px-4 flex justify-end border-t">
          <DialogClose asChild>
            <Button onClick={onClose} className="bg-blue-500 hover:bg-blue-500">
              Close
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
